import { render } from "./UIScreen.vue?vue&type=template&id=46a57975&scoped=true"
import script from "./UIScreen.vue?vue&type=script&lang=js"
export * from "./UIScreen.vue?vue&type=script&lang=js"

import "./UIScreen.vue?vue&type=style&index=0&id=46a57975&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a57975"]])

export default __exports__